import React, {FunctionComponent} from "react";
import clsx from "clsx";
import {LabelWidth} from "../inputs/MultipleChoiceInput";
import {AnswerDistributionLabel, Direction} from "../../common/AnswerDistributionLabel";
import {MCHeightLg} from "../common/questionConstants";
import {createUseStyles} from "react-jss";
import DisplayText, {TextVariant} from "engage-client/components/DisplayText";
import UserProvidedText from "engage-client/components/UserProvidedText";


type MCOptionProps = {
	answerCount?:number
	color: string
	index: number
	label: string
	percent?: number
	selected?: boolean
}

const Animation = ".25s ease-in-out";

const Border = 3;

const useOptionStyles = createUseStyles({
	mcOption: {
		display: "flex",
		overflow: "hidden",
		border: (props) => `${Border}px solid ${props.color}`,
		borderRadius: 10,
		height: MCHeightLg
	},
	option: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		background: (props) => props.color,
		border: "none",
		borderTopLeftRadius: 2,
		borderBottomLeftRadius: 2,
		padding: "2px 6px",
		color: "#fff",
		minWidth: LabelWidth
	},
	content: {
		position: "relative",
		flex: 1
	},
	text: {
		position: "absolute",
		left: 0,
		right: 0,
		top: 0,
		bottom: 0,
		display: "inline-flex",
		alignItems: "center",
		padding: "2px 6px",
		background: "rgba(255,255,255, .8)",
		fontFamily: '"Anova", "Roboto", "Helvetica", "Arial", "sans-serif"',
		letterSpacing: 0,
		fontWeight: 400,
	},
	overlayText: {
		transition: `clip-path ${Animation}, -webkit-clip-path ${Animation}`,
		color: "#fff",
		clipPath: "inset(0 100% 0 0)",
		"-webkit-clip-path": "inset(0 100% 0 0)",
		overflow: "hidden",
		background: (props) => props.color,
		".selected ~ * &": {
			clipPath: (props) => `inset(0 ${100 - props.percent}% 0 0)`,
			"-webkit-clip-path": (props) => `inset(0 ${100 - props.percent}% 0 0)`,
		}
	},
	countContainer: {
		position: "relative",
		marginLeft: LabelWidth + Border,
		marginRight: Border
	},
});

const MultipleChoiceOption:FunctionComponent<MCOptionProps> = ({
								answerCount,
								color,
								label,
							    percent = 100,
								selected = false,
								children,
								}) => {
	
	const classes = useOptionStyles({color: color, percent: percent});
	return <div>
		<div className={classes.mcOption}>
			<DisplayText component="span" variant={TextVariant.s22reg} className={clsx(selected && "selected", classes.option)}>{label}</DisplayText>
			<div className={classes.content}>
				<UserProvidedText maxFont={[22,20,16]} className={classes.text} color="black">
					{children}
				</UserProvidedText>
				<UserProvidedText maxFont={[22,20,16]} className={clsx(classes.text, classes.overlayText)}>
					{children}
				</UserProvidedText>
			</div>
		</div>
		{typeof answerCount !== "undefined" ? <div className={classes.countContainer}>
			<AnswerDistributionLabel color={color} direction={Direction.Up} style={{left: `${percent}%`}}>{answerCount}</AnswerDistributionLabel>
		</div> : null}
	</div>;
};

export default MultipleChoiceOption;